export enum WidgetMessageType {
  Init = 'dest1PhoenixWidgetInit',
  WidgetConfig = 'dest1PhoenixWidgetConfig',
  StartMain = 'dest1PhoenixStartMain',
  HideIframe = 'dest1PhoenixHideIframe'
}
